import React from 'react';
import Heading from '../../../../components/Heading';
import PaddingBox from '../../../../components/PaddingBox';

export const AuthenticationTitle = ({ children }) => {
	return (
		<PaddingBox bottomSmall>
			<Heading size={4}>{children}</Heading>
		</PaddingBox>
	);
};
